import { ResponsiveBehavior } from "layoutSystems/common/utils/constants";
import type { WidgetDefaultProps } from "WidgetProvider/types";

export const defaultsConfig = {
  widgetName: "ToolbarButtons",
  orientation: "horizontal",
  variant: "ghost",
  color: "accent",
  isDisabled: false,
  isVisible: true,
  version: 1,
  animateLoading: true,
  responsiveBehavior: ResponsiveBehavior.Fill,
  buttonsList: {
    button1: {
      label: "Add",
      isVisible: true,
      isDisabled: false,
      widgetId: "",
      id: "button1",
      index: 0,
      icon: "plus",
      iconPosition: "start",
    },
    button2: {
      label: "Edit",
      isVisible: true,
      isDisabled: false,
      widgetId: "",
      id: "button2",
      index: 1,
      icon: "pencil",
      iconPosition: "start",
    },
    button3: {
      label: "Copy",
      isVisible: true,
      isDisabled: false,
      widgetId: "",
      id: "button3",
      index: 2,
      icon: "copy",
      iconPosition: "start",
    },
    separator: {
      isVisible: true,
      isDisabled: false,
      isSeparator: true,
      widgetId: "",
      id: "separator",
      index: 2,
      label: "Separator",
      itemType: "SEPARATOR",
    },
    button4: {
      label: "Delete",
      isVisible: true,
      isDisabled: false,
      widgetId: "",
      id: "button4",
      index: 2,
      icon: "trash",
      iconPosition: "start",
    },
  },
} as unknown as WidgetDefaultProps;
